import React, { FC, MouseEventHandler } from 'react';
import { SelectionMovie } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { RouterLocation } from '@funtech-int/rival';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';
import { Picture, createPictureFactory } from '@funtech-int/yango-shared';

import { RouterLink } from '@/shared/components/RouterLink/RouterLink';
import { AnimatedTopNumberIcon } from '@/shared/assets/AnimatedNumberIcon';

import styles from './_Top10.module.css';

const pictureFactory = createPictureFactory({
    fallback: {
        srcSet: {
            '1x': '146x220',
            '2x': '292x440',
        },
        src: '146x220',
    },
});

interface Top10Props {
    movie: SelectionMovie;
    position: number;
    location: RouterLocation<any, any>;
    isHighlighted?: boolean;
    onShow?: VoidFunction;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const Top10: FC<Top10Props> = ({
    movie,
    position,
    location,
    isHighlighted,
    onShow,
    onClick,
}) => {
    const cardPosition = position + 1;

    const { ref } = useInView({
        onChange(inView: boolean) {
            if (inView) {
                onShow?.();
            }
        },
        threshold: 0.8,
    });

    const { img } = pictureFactory({
        fallbackUrl: movie.verticalPoster?.toString(),
    });

    return (
        <RouterLink
            to={location}
            className={classnames(styles.root, {
                [styles.highlighted]: isHighlighted,
            })}
            onClick={onClick}
            ref={ref}
            dataTid="CardTop10"
        >
            <AnimatedTopNumberIcon
                rootClassName={styles.iconTopTen}
                shapePathClassName={styles.iconShapeTopTen}
                cardIndex={position}
                getMaskClassName={(maskIndex: number) =>
                    styles[`num${cardPosition}mask${maskIndex + 1}`]
                }
            />
            <div className={styles.imageContainerTopTen}>
                <div className={styles.borderPointerTopTen} />
                <div className={styles.imageOverlayMask}>
                    <Picture
                        className={styles.imageTopTen}
                        alt={movie.title.toString()}
                        loading="lazy"
                        srcSet={img.srcSet}
                        src={img.src}
                        data-tid="AdaptiveImage"
                    />
                    <div
                        className={classnames(
                            styles.imageOverlayTopTen,
                            styles[`imageOverlayTopTenNum${cardPosition + 1}`]
                        )}
                    />
                </div>
                <div className={styles.borderTopTen} />
            </div>
        </RouterLink>
    );
};
